import { WineToursScreen } from '@/components/riviera/wine-tours-screen';

// Regional wine-tour hub. No generateStaticParams of its own — the `lang`
// params and the list seed both come from app/[lang]/_layout.tsx, as for
// /[lang]/tours.
export default function WineToursHubScreen() {
  return <WineToursScreen />;
}
